<template>
  <q-btn-dropdown
    v-if="campaigns && campaigns.length > 0 && selectedCampaign"
    flat dense icon="las la-history"
    @click="showDropdownCampaigns = true"
  >
    <q-menu
      :offset="!isHeader ? [64, 0] : [0, 0]"
      class="q-py-xs"
      anchor="bottom right"
      self="top right"
      v-model="showDropdownCampaigns"
    >
      <q-timeline class="q-px-md">
        <q-timeline-entry
          v-for="poi in history" :key="poi.id"
          :subtitle="timelineSubtitle(poi)"
          side="left"
          class="cursor-pointer"
          :color="selectedCampaign && selectedCampaign.id === poi.properties.campaign ? 'balck' : 'grey-4' "
          :icon="selectedCampaign && selectedCampaign.id === poi.properties.campaign ? 'check' : undefined "
          @click="onCampaignClick(poi)"
          v-close-popup
        >
          <img v-if="poi.properties.filename" :src="imageSrc(poi)" alt="" style="height: 65px">
          <div v-else class="text-grey-8">No hi ha panorames disponibles en aquesta zona</div>
        </q-timeline-entry>
      </q-timeline>
    </q-menu>
  </q-btn-dropdown>
</template>

<script>
import { ClosePopup, QBtnDropdown, QTimeline, QTimelineEntry, QMenu } from 'quasar'
import { mapState } from 'vuex'

export default {
  props: ['isHeader'],
  data () {
    return {
      showDropdownCampaigns: false
    }
  },
  components: {
    QBtnDropdown, QTimeline, QTimelineEntry, QMenu
  },
  directives: {
    ClosePopup
  },
  computed: {
    ...mapState({
      campaigns: state => state.panorama.campaigns,
      selectedCampaign: state => {
        return state.panorama.selectedCampaign
      },
      history: state => {
        return state.panorama.history?.map(poi => {
          poi.campaignInfo = state.panorama.campaigns.find(campaign => campaign.id === poi.properties.campaign)
          return poi
        })
      },
      metadataMethods: state => state.panorama.metadataMethods
    })
  },
  methods: {
    onCampaignClick (poi) {
      this.$store.commit('panorama/setCampaignSelectedByUser', true)
      this.$store.dispatch('panorama/selectCampaignByPoi', poi)
      this.$store.dispatch('panorama/setPoi', poi)
      this.$store.dispatch('panorama/setSrcPannellum')
    },
    timelineSubtitle (poi) {
      let title = poi.properties.date.split('T')[0].split('-').reverse().join('/') + ' - ' + poi.campaignInfo.name
      if (poi.campaignInfo.metadata) {
        title += ' ('
        let metadata = []
        if (poi.campaignInfo.metadata.method) {
          metadata.push(this.metadataMethods[poi.campaignInfo.metadata.method - 1])
        }
        if (poi.campaignInfo.metadata.precision) {
          metadata.push(poi.campaignInfo.metadata.precision)
        }
        title += metadata.join(' - ') + ')'
      }
      return title
    },
    imageSrc (poi) {
      let filename = [
        this.$config.panoramas.media,
        poi.campaignInfo.folder_pano,
        poi.properties.folder,
        poi.properties.filename
      ].filter(path => !!path).join('/')
      return poi.properties.has_mini ? filename.replace('.jpg', '_@.jpg') : filename
    }
  }
}
</script>

<style scoped>
.q-timeline__dot.text-black {
  width: 20px
}
</style>
